import { LinkingToolContainer } from '@/modules/LinkingTool';

export const LinkingTool = (): JSX.Element => <LinkingToolContainer />;

export default LinkingTool;
